import { jsx as _jsx } from "react/jsx-runtime";
import Widget from 'app/components/Widget/Widget.jsx';
import { router } from 'app/containers/Assets/AssetDetail/router';
import AssetsTreeSearch from 'app/containers/Assets/AssetsTree/AssetsTreeSearch.jsx';
import { colors } from 'app/styles/vars.js';
const Assets = () => {
    const onClickAsset = ({ metadata }) => {
        router.goTo('index', { assetId: metadata.id }, { rightPanel: true });
    };
    return (_jsx(Widget, { style: { display: 'flex' }, children: _jsx(AssetsTreeSearch, { assetTypesCreationAllowed: ['ep', 'fo', 'mo', 'pj', 'sh', 'mi'], onClickItem: onClickAsset, assetTypes: ['ep', 'fo', 'mo', 'sh', 'gp', 'us', 'pj', 'of', 'ph', 'lc', 'mi'], iconColor: colors.yuzuPrimaryColor }) }));
};
export default Assets;
